import actions from './actions'

export default function VorlagesReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_VORLAGE:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_VORLAGE:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_VORLAGE:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_VORLAGE:
      return {
        ...state,
        editing: { vorlageID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_VORLAGE_RECIEVED ||
      actions.UPDATE_VORLAGE_RECIEVED ||
      actions.DELETE_VORLAGE_RECIEVED:
      return {
        ...state,
        editing: { vorlageID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
